
export function parse_employees(employee) {
    return {
        //"idEstablishment": employee.idEstablishment,
        "phone": employee.phone,
        "name": employee.name,
        "email": employee.email,
        "_id": employee._id,
        "employee_details": {
            "job": employee.job,
            "birth": employee.birth,
            "establishment": employee.establishment,
            "address": employee.address
        }

    };
}
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
